/**
 * Loads modules required for the main content matrix
 */

import { loadModulesWhenInView } from '@helpers/loadModule';
// quoteLinks is also required by Vue instances which are imported statically anyway
import quoteLinks from '@modules/quoteLinks';

export default function init(): void {
  // Load required modules immediately
  quoteLinks([...document.querySelectorAll<HTMLAnchorElement>('.quote-link')]);

  // Load optional modules when in view
  loadModulesWhenInView([
    {
      selector: '.js-accordion-item',
      importer: () => import('@modules/accordion'),
    },
    {
      selector: '.js-cover-levels-toggle',
      importer: () => import('@modules/coverLevels'),
    },
    {
      selector: '.fui-form:not(.crm-form)',
      importer: () => import('@modules/formieCsrf'),
    },
    {
      selector: '.fui-form:not(.crm-form)',
      importer: () => import('@modules/gtmFormSubmission'),
    },
    {
      selector: '.js-social-share-button',
      importer: () => import('@modules/socialShare'),
    },
    {
      selector: '.js-swiper',
      importer: () => import('@modules/swiper'),
    },
    {
      selector: '.js-video-container',
      importer: () => import('@modules/video'),
    },
    {
      selector: '.js-footer-skip-link',
      importer: () => import('@modules/footerSkipLink'),
    },
  ]);
}
